import { gql, QueryHookOptions, QueryResult, useQuery } from '@apollo/client';
import {
  GetTopDetectionsByDetectionGroupsPerEntityFullQuery,
  GetTopDetectionsByDetectionGroupsPerEntityFullQueryVariables,
} from '@investigator/shared/generated/graphql';

export const GET_TOP_DETECTIONS_BY_DETECTION_GROUPS_PER_ENTITY = gql`
  query GetTopDetectionsByDetectionGroupsPerEntityFull(
    $tenant_entity: String!
    $group_by: DetectionGroups!
    $tenant: String
    $end: Float!
    $size: Int!
    $sort: [SortParameterInput]
    $start: Float!
  ) {
    getTopDetectionsByDetectionGroupsPerEntity(
      tenant_entity: $tenant_entity
      group_by: $group_by
      tenant: $tenant
      end: $end
      size: $size
      sort: $sort
      start: $start
    ) {
      tenant_entity
      tenant
      end
      size
      start
      group_by
      data {
        group_key
        detections_count
        detections {
          rank {
            severity
            is_custom_severity
          }
          alert_info {
            alert_name
            alert_type
          }
          alert_entity {
            entity_id
            entity_name
            entity_type
            entity_category
          }
          tenant
          detection_id
          created_timestamp
          detection_status
          earliest_start_timestamp
          latest_start_timestamp
          mitre_tactics
          mitre_techniques
          total_alert_count
          logscale_query
        }
      }
    }
  }
`;

export const useGetTopDetectionsByDetectionGroupsPerEntity = (
  options: QueryHookOptions<
    GetTopDetectionsByDetectionGroupsPerEntityFullQuery,
    GetTopDetectionsByDetectionGroupsPerEntityFullQueryVariables
  >,
): QueryResult<
  GetTopDetectionsByDetectionGroupsPerEntityFullQuery,
  GetTopDetectionsByDetectionGroupsPerEntityFullQueryVariables
> => {
  return useQuery<
    GetTopDetectionsByDetectionGroupsPerEntityFullQuery,
    GetTopDetectionsByDetectionGroupsPerEntityFullQueryVariables
  >(GET_TOP_DETECTIONS_BY_DETECTION_GROUPS_PER_ENTITY, options);
};
